export default __webpack_public_path__ + "static/media/Akropolis.b94bab93.svg";